export function columnToIndex(label) {
  return String(label || "").toUpperCase().split("").reduce((acc, char) => acc * 26 + char.charCodeAt(0) - 64, 0);
}

export function indexToColumn(index) {
  let label = "";
  let value = Number(index || 0);
  while (value > 0) {
    const remainder = (value - 1) % 26;
    label = String.fromCharCode(65 + remainder) + label;
    value = Math.floor((value - 1) / 26);
  }
  return label || "A";
}

export function parseAddress(address) {
  const match = String(address || "").toUpperCase().match(/^([A-Z]+)([1-9][0-9]*)$/);
  if (!match) throw new Error("Invalid A1 address");
  return { column: columnToIndex(match[1]), row: Number(match[2]), address: `${match[1]}${match[2]}` };
}

export function addressFrom(column, row) {
  return `${indexToColumn(column)}${row}`;
}

export function parseRange(range) {
  const [left, right = left] = String(range || "A1").split(":");
  const start = parseAddress(left);
  const end = parseAddress(right);
  return {
    start: { column: Math.min(start.column, end.column), row: Math.min(start.row, end.row) },
    end: { column: Math.max(start.column, end.column), row: Math.max(start.row, end.row) }
  };
}

export function rangeToGrid(range) {
  const parsed = parseRange(range);
  const columns = [];
  const rows = [];
  for (let column = parsed.start.column; column <= parsed.end.column; column += 1) columns.push(column);
  for (let row = parsed.start.row; row <= parsed.end.row; row += 1) rows.push(row);
  return { ...parsed, columns, rows, columnCount: columns.length, rowCount: rows.length };
}

export function frozenPaneClasses(cell, freeze = {}) {
  const classes = [];
  if (freeze.row && cell.row <= freeze.row) classes.push("is-frozen-row");
  if (freeze.column && cell.column <= freeze.column) classes.push("is-frozen-col");
  if (classes.length === 2) classes.push("is-frozen-corner");
  return classes;
}

export function moveSelection(address, key, range) {
  const current = parseAddress(address);
  const bounds = parseRange(range);
  const delta = {
    ArrowUp: [0, -1],
    ArrowDown: [0, 1],
    ArrowLeft: [-1, 0],
    ArrowRight: [1, 0],
    Tab: [1, 0],
    Enter: [0, 1]
  }[key] || [0, 0];
  const column = Math.max(bounds.start.column, Math.min(bounds.end.column, current.column + delta[0]));
  const row = Math.max(bounds.start.row, Math.min(bounds.end.row, current.row + delta[1]));
  return addressFrom(column, row);
}

export function compactCellDisplay(value, maxLength = 18) {
  const text = String(value ?? "");
  if (text.length <= maxLength) return text;
  return `${text.slice(0, Math.max(1, maxLength - 1))}…`;
}

export function clampSheetSize(value, min, max) {
  const number = Number(value);
  const fallback = Number(min || 0);
  if (!Number.isFinite(number)) return fallback;
  return Math.max(min, Math.min(max, Math.round(number)));
}

export function sheetTrackTemplate(indices, sizes = {}, fallback, min, max) {
  return indices
    .map((index) => `${clampSheetSize(sizes?.[index] === undefined ? fallback : sizes[index], min, max)}px`)
    .join(" ");
}
